import { get } from 'lodash';
import { styled } from '@mui/material/styles';
import { ScoringInformationDto } from 'models/dtoTypes';
import Alert from '@mui/material/Alert';

const PREFIX = 'ScoreInformation';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

type Severity = 'info' | 'success' | 'warning' | 'error' | undefined;

const severityMapper: { [key: string]: Severity } = {
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
  Danger: 'error',
};

interface Props {
  information?: ScoringInformationDto[];
}

function ScoreInformation(props: Props): JSX.Element {
  const { information } = props;

  if (!information) return <></>;
  return (
    <Root className={classes.root}>
      {information.map((inf, i) => (
        <Alert key={i} variant="outlined" severity={get(severityMapper, inf.type || '')}>
          {inf.message}
        </Alert>
      ))}
    </Root>
  );
}

export default ScoreInformation;
